<template>
  <div class="ren-decoration-cp ren-decoration-cp-action-card">
    <i :style="iconStyle">更</i>
    <div>
      <strong>{{ heading }}</strong>
      <span>{{ content }}</span>
    </div>
    <button type="button" :style="buttonStyle">{{ buttonText }}</button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { stringValue } from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()

const heading = computed(() =>
  `${stringValue(props.component.props?.title, '应用新版本')} ${stringValue(props.component.props?.version)}`.trim()
)
const content = computed(() => stringValue(props.component.props?.content))
const buttonText = computed(() => stringValue(props.component.props?.buttonText, '立即体验'))
const iconStyle = computed(() => ({
  backgroundColor: props.themeTokens?.primaryColor || props.themeColor || 'var(--ren-theme-primary)'
}))
const buttonStyle = computed(() => ({
  backgroundColor: props.themeTokens?.primaryColor || props.themeColor || 'var(--ren-theme-primary)',
  color: '#fff'
}))
</script>
